/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";

// REDUX
import { connect } from "react-redux";

// MAIN ROUTES
import {
  initialize,
  openSession,
  automaticallyShowInAppMessages,
  requestContentCardsRefresh,
  getDeviceId,
  destroy
} from "@braze/web-sdk";
import _ from "lodash";
import UserRoutes from "../../routes/UserRoutes/UserRoutes";
import ProductRoutes from "../../routes/ProductRoutes/ProductRoutes";
import CheckoutRoutes from "../../routes/CheckoutRoutes/CheckoutRoutes";
import IndexRoutes from "../../routes/IndexRoutes/IndexRoutes";

// 404 ROUTE
import NoMatch from "../NoMatch/NoMatch";

// COMPONENTS
import Modal from "../../components/Modal/Modal";
import MobileMenu from "../../components/MobileMenu/MobileMenu";

import styles from "./PageContainer.module.css";
import * as countryActions from "../../redux/actions/country";
import * as footerSettingsActions from "../../redux/actions/footerSettings";
import defaultCountry from "../../shared/constants/country";
import Loader from "../../components/Loader/Loader";

import * as doughProActions from "../../redux/actions/doughPro";
import * as shippingActions from "../../redux/actions/shipping";
import * as productActions from "../../redux/actions/product";
import * as brazeActions from "../../redux/actions/braze";
import * as elementsActions from "../../redux/actions/elements";
import * as siteSettingRepo from "../../shared/repos/graphql/siteSetting";
import * as tipsActions from "../../redux/actions/tips";
import * as loyaltyActions from "../../redux/actions/loyalty";
import * as giftCardActions from "../../redux/actions/giftCard";
import * as orderTotalsTitles from "../../redux/actions/orderTotalsTitles";
import * as contactUsSettingActions from "../../redux/actions/contactUsSetting";
import * as addressActions from "../../redux/actions/address";
import * as eventActions from "../../redux/actions/event";
import * as siteSettingsActions from "../../redux/actions/siteSettings";
import {
  getCountries,
  getPhonePrefixes
} from "../../shared/repos/graphql/country";
import siteSetting from "../../shared/constants/siteSetting";
import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";
import * as brazeRepo from "../../shared/repos/marketing/braze";
import ddRum from "../../shared/utilities/datadog/rum";
import { sendGeolocationToBraze } from "../../shared/utilities/braze";
import endpoints from "../../shared/constants/endpoints";
import { defaultCurrency } from "../../shared/constants/currency";
import CheckoutButton from "../../components/CheckoutButton/CheckoutButton";
import FullScreenCheckoutButton from "../../components/CheckoutButton/FullScreenCheckoutButton";
import {
  getCheckoutButtonMenuProps,
  getStickyCtaRegionProps
} from "../../components/CheckoutButton/checkoutButtonBrandRefreshClasses";
import elementConstant from "../../shared/constants/element";
// UTILS
import {
  // renderBackground,
  renderGlobalHeader,
  renderGlobalFooter
} from "../../shared/utilities/renderings";
import Error from "../../components/Error/Error";
import {
  isHasCountryPathInLocation,
  addCountryPathToLocation,
  getLocationWithoutCountryPath,
  removeCountryPathFromLocation
} from "../../shared/utilities/pathes";
import tipsTypes from "../../shared/constants/tipsTypes";
import * as userActions from "../../redux/actions/user";
import { store as mainStore } from "../../redux/store";
import * as customCakeTopperActions from "../../redux/actions/customCakeTopper";
import * as currencyActions from "../../redux/actions/currency";
import { clearStorage, routeCountryPath } from "../../shared/utilities/common";
import {
  checkoutOrderMinAmount,
  getCartProductIds,
  getCartSubtotal,
  getLoyaltyDiscountAmount
} from "../../shared/utilities/orders";
import { orderMethods } from "../../shared/constants/order";
import * as orderRepo from "../../shared/repos/graphql/order";
import { ids } from "../../shared/constants/locales";
import * as themeActions from "../../redux/actions/theme";
import PostOrderExperienceModal from "../../components/OrderExperience/PostOrderExperienceModal";
import { OrderEvent } from "../../shared/constants/OrderEvent";
import BigOrderWarningModal from "../../components/BigOrderWarningModal/BigOrderWarningModal";

import * as cms from "../../shared/repos/cms/cms";
import cmsKeys from "../../shared/constants/cms";

class PageContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      content: []
    };
  }

  componentDidMount = async () => {
    const {
      setSelectedCountry,
      setUserZoneId,
      resetUserData,
      resetCustomCakeTopperData,
      resetCurrencyData,
      userCartId,
      dataCollectionDelay,
      setEnableDefaultAddressForGuestUsers
    } = this.props;
    try {
      const { userZoneId } = mainStore.getState().user;
      const zoneId = Number(window.environment.REACT_APP_ZONE_ID ?? 1);

      if (userZoneId && zoneId && userZoneId !== zoneId) {
        resetCustomCakeTopperData();
        resetCurrencyData();
        resetUserData();
        clearStorage();
        setUserZoneId(zoneId);
      }

      if (!userZoneId) {
        setUserZoneId(zoneId);
      }

      if (userCartId) {
        await orderRepo.getOrder(userCartId);
      }

      const resp = await this.getSiteSettings();
      const allSettings = resp.data.siteSettings;
      const countryActiveParam = _.find(allSettings, {
        name: siteSetting.COUNTRY_SELECTION_ENABLED,
        country_id: null
      });
      let registerBrazeSetting = null;
      const enableDefaultAddressForGuestUsers = _.find(allSettings, {
        name: siteSetting.ENABLE_GUEST_USERS_LAST_ORDER_ADDRESS,
        country_id: null
      });
      setEnableDefaultAddressForGuestUsers(
        parseInt(enableDefaultAddressForGuestUsers?.value, 10) === 1
      );
      if (countryActiveParam && +countryActiveParam.value) {
        const selectedCountry = await this.handleCountry();
        const specific = this.setSiteSettingsByCountry(
          allSettings,
          +selectedCountry.id
        );
        ddRum.initialize(specific);
        this.setState({ isLoading: false });
        registerBrazeSetting = specific;
      } else {
        const common = this.setSiteSettingsByCountry(allSettings, null);
        ddRum.initialize(common);
        setSelectedCountry(defaultCountry);
        this.setState({ isLoading: false });
        registerBrazeSetting = common;
      }

      if (dataCollectionDelay) {
        setTimeout(() => {
          this.registerBraze(registerBrazeSetting);
        }, dataCollectionDelay);
      } else {
        this.registerBraze(registerBrazeSetting);
      }

      getPhonePrefixes().then(res => {
        countryActions.setPhonePrefixes(res.data.phonePrefixes);
      });

      // Load CMS content first, then set page title and description
      await cms.getContent([cmsKeys.seoMeta], this);

      // Set initial page title and description only for pages that don't manage their own titles
      const { location } = this.props;

      if (!this.pageManagesOwnTitle(location.pathname)) {
        this.updatePageTitleAndDescription();
      }
    } catch (e) {
      setSelectedCountry(defaultCountry);
      this.setState({ isLoading: false });
    }
  };

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const { location: prevLocation } = prevProps;

    // Check if the route has changed
    if (location.pathname !== prevLocation.pathname) {
      // Only update title/description for pages that don't manage their own titles
      // This ensures titles are updated when navigating between routes
      if (!this.pageManagesOwnTitle(location.pathname)) {
        this.updatePageTitleAndDescription();
      }
    }
  }

  pageManagesOwnTitle = pathname => /products\/|store\/|^\/news(\/|$)/.test(pathname);

  /**
   * Updates the page title and meta description based on the current route.
   * This method is called from componentDidMount (after CMS content is loaded)
   * and componentDidUpdate (when routes change) to ensure proper SEO.
   */
  updatePageTitleAndDescription = () => {
    const { location } = this.props;

    // Snack Madness sweepstakes page uses its own title (PageContainer runs after SnackMadness mount)
    if (location.pathname.includes("bracket")) {
      document.title = "Insomnia Cookies | Win A Sweet Trip";
      return;
    }

    // Snack Madness sweepstakes terms page (static Official Rules)
    if (location.pathname.includes("snack-madness-sweeps-terms")) {
      document.title = "Sweepstakes Terms and Conditions | Insomnia Cookies";
      return;
    }

    // PJ Party Dream Dorm Giveaway terms page (CMS Official Rules)
    if (location.pathname.includes(endpoints.dreamDormGiveawayTerms)) {
      document.title = "PJ Party Dream Dorm Giveaway Official Rules | Insomnia Cookies";
      return;
    }

    // Insomnia Cookies 23rd Birthday Giveaway terms page (CMS Official Rules)
    if (location.pathname.includes(endpoints.insomnia23rdBirthdayGiveawayTerms)) {
      document.title = "Insomnia Cookies 23rd Birthday Giveaway Official Rules | Insomnia Cookies";
      return;
    }

    const defaultTitle = "Easy Ordering & Sweet Rewards | Insomnia Cookies";
    const currentTitle =
      this.getSeoMetaByPath(location.pathname, "title")?.value || defaultTitle;
    const currentDescription =
      this.getSeoMetaByPath(location.pathname, "description")?.value || "";

    // Update document title
    document.title = currentTitle;

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = currentDescription;
  };

  getSeoMetaContent = () => {
    const { content } = this.state;

    return content.filter(item => {
      return item.key === cmsKeys.seoMeta;
    });
  };

  getSeoMetaByPath = (path, field) => {
    const seoMetaContent = this.getSeoMetaContent();
    let value = "";
    const childHasContent = field && seoMetaContent.length > 0;
    if (childHasContent) {
      const seoMeta = seoMetaContent[0]?.children?.filter(item => {
        return item.key === path;
      });

      const data = seoMeta[0]?.children?.filter(item => {
        return item.key === field;
      });
      value = data?.length > 0 ? data[0].value : "";
    }
    return {
      value
    };
  };

  handleCountry = () => {
    const { setAllCountries, setSelectedCountry, selectedCountry } = this.props;
    return new Promise((resolve, reject) => {
      const zoneId = Number(window.environment.REACT_APP_ZONE_ID ?? 1);
      let pathname = window.location.pathname.slice(1);
      const matches = pathname.match(/^[a-z]{2}(\/|$)/g);
      if (pathname.length >= 2 && matches && matches.length > 0) {
        pathname = matches[0].replace("/", "");
      } else {
        pathname = "";
      }
      getCountries()
        .then(res => {
          if (!res || !res.data || !res.data.countries) {
            reject();
          } else {
            const { all, selected } = res.data.countries;
            let activeCountry;
            setAllCountries(all);
            if (
              selectedCountry &&
              selectedCountry.id === null &&
              selected &&
              pathname === ""
            ) {
              activeCountry = selected;
            } else if (pathname !== (selected.path_url ?? "")) {
              all.forEach(country => {
                if (pathname === (country.path_url ?? "")) {
                  activeCountry = country;
                }
              });
            }
            if (
              activeCountry === undefined &&
              selectedCountry &&
              selectedCountry.id &&
              (selectedCountry.path_url ?? "") === pathname
            ) {
              activeCountry = _.find(all, { id: selectedCountry.id });
            }
            if (activeCountry === undefined) {
              activeCountry = selected;
            }
            if (+activeCountry.zone_id === +zoneId) {
              setSelectedCountry(activeCountry);
            } else {
              window.location.href = activeCountry.path_url ?? "";
            }

            resolve(activeCountry);
          }
        })
        .catch(reject);
    });
  };

  registerBraze = settings => {
    const {
      introBannerVisibilityUpdated,
      shouldDisplayIntroBanner,
      setContentCardRefreshDelay
    } = this.props;
    const scriptEnvironments = ["local", "dev", "production", "staging"];
    const brazeApiKey = _.find(settings, {
      name: siteSetting.BRAZE_APP_ID_WEB
    });
    const brazeVerboseLogging = _.find(settings, {
      name: siteSetting.BRAZE_VERBOSE_LOGGING
    });
    const cardRefreshDelay = _.find(settings, {
      name: siteSetting.CONTENT_CARD_REFRESH_DELAY
    });
    const delay = parseInt(cardRefreshDelay.value, 10);
    setContentCardRefreshDelay(delay);

    if (
      brazeApiKey &&
      brazeApiKey.value !== "" &&
      scriptEnvironments.includes(window.environment.REACT_APP_ENV)
    ) {
      destroy();
      initialize(brazeApiKey.value, {
        baseUrl: window.environment.REACT_APP_BRAZE_ENDPOINT,
        enableLogging: brazeVerboseLogging?.value === "1",
        allowUserSuppliedJavascript: true,
        inAppMessageZIndex: 12000
      });
      automaticallyShowInAppMessages();
      brazeRepo.subscribeToContentCardUpdates();
      openSession();
      // Get device ID and save it
      const deviceId = getDeviceId();
      if (deviceId && deviceId.trim() !== "") {
        siteSettingRepo
          .saveDeviceId(deviceId, ids.appVersion)
          .then(() => {})
          .catch(() => {});
      }

      // The content cards refresh is now called immediately in braze.js subscribeToContentCardUpdates()
      // Keep the delayed call as a fallback/retry mechanism in case the initial request fails
      setTimeout(() => {
        requestContentCardsRefresh();
        if (shouldDisplayIntroBanner) {
          introBannerVisibilityUpdated(false);
        }
      }, delay);

      sendGeolocationToBraze();
    }
  };

  setSiteSettingsByCountry = (settings, countryId = null) => {
    let specificSettings = [];
    const commonSettings = _.filter(settings, setting => {
      return setting.country_id === null;
    });
    if (countryId === null) {
      specificSettings = commonSettings;
    } else {
      const byCountry = _.filter(settings, setting => {
        return setting.country_id === countryId;
      });
      specificSettings = _.map(commonSettings, setting => {
        const byCountrySetting = _.find(byCountry, { name: setting.name });
        return byCountrySetting ?? setting;
      });
    }
    const {
      setIsDoughProActive,
      isDoughProActive,
      setIsShippingActive,
      isShippingActive,
      setIsCaloriesActive,
      isCaloriesActive,
      setIsCountrySelectActive,
      isCountrySelectActive,
      setDefaultHeroBanner,
      setCarouselSpeed,
      setIscontentCardFullWidth,
      setIntroHeroBanner,
      setTiktokLink,
      setInstagramLink,
      setFacebookLink,
      setFooterMenuItemsSettings,
      setFooterMenuItemsLinksSettings,
      setTipsSettings,
      setIsGiftcardDisabled,
      setOrderTotalsTitles,
      setShowTaxesAfterTotal,
      setDefaultMapCoordinates,
      setContactUsSettings,
      setUseFullyQualifiedAddressForDelivery,
      setThemeSettings,
      setPasswordlessEmailLoginEnable,
      setOtpAuthenticationEnabledWebsite,
      setActiveLoyaltySetting,
      setReferralEnabledSetting,
      setUseRecaptcha,
      setIsShowOosProducts,
      setIsFeedbackFormsEnabled,
      setPlatformWalletLoyaltyCardFeature,
      setDataCollectionDelay,
      setDeliveryPickupWidgetEnabled,
      setBrazeContentCardLink,
      setBrazeContentCardLinkReplaceWith,
      setEventEndDate,
      setEventApplicationLogoWebsite,
      setEventApplicationLogoMobile,
      setMockBrazeContentCards
    } = this.props;
    const footerMenuItemsSettings = {
      [siteSetting.IS_FOOTER_MENU_NEWSROOM_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_FAQ_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_PRIVACY_POLICY_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_TERMS_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_EVENT_TERMS_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_ACCESSIBILITY_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_CONTACT_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_ABOUT_US_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_CAREERS_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_CORPORATE_SALES_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_DONATIONS_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_MERCH_ENABLED]: false,
      [siteSetting.IS_FOOTER_MENU_ALLERGEN_ENABLED]: false
    };

    const contactUsSetting = {
      [siteSetting.IS_FOOTER_MENU_NEWSROOM_ENABLED]: false,
      [siteSetting.IS_CONTACT_US_FEEDBACK_ENABLE]: false,
      [siteSetting.IS_CONTACT_US_GENERAL_ENABLE]: false,
      [siteSetting.IS_CONTACT_US_EVENTS_ENABLE]: false,
      [siteSetting.IS_CONTACT_US_REAL_ESTATE_ENABLE]: false,
      [siteSetting.IS_CONTACT_US_VENDOR_ENABLE]: false,
      [siteSetting.IS_CONTACT_US_PRESS_ENABLE]: false,
      [siteSetting.IS_CONTACT_US_MERCH_ENABLE]: false,
      [siteSetting.IS_CONTACT_US_DONATION_ENABLE]: false,

      [siteSetting.CONTACT_US_FEEDBACK_EMAILS]: "",
      [siteSetting.CONTACT_US_GENERAL_EMAILS]: "",
      [siteSetting.CONTACT_US_EVENTS_EMAILS]: "",
      [siteSetting.CONTACT_US_REAL_ESTATE_EMAILS]: "",
      [siteSetting.CONTACT_US_VENDOR_EMAILS]: "",
      [siteSetting.CONTACT_US_PRESS_EMAILS]: ""
    };
    const tipsSettings = {
      [siteSetting.TIPS_TYPE]: tipsTypes.TYPE_PERCENT,
      [siteSetting.TIPS_VALUES]: [18, 20, 25]
    };
    const footerMenuItemsLinks = {};
    const themeSettings = {
      [siteSetting.IS_THEME_SWITCH_ENABLED]: false
    };

    // Track passwordless email login and OTP settings for combined logic
    let passwordlessEmailLoginEnabledValue = false;
    let otpAuthenticationEnabledWebsite = false;

    specificSettings.forEach(siteSettings => {
      const { name, value } = siteSettings;
      switch (name) {
        case siteSetting.COOKIE_MAGIC_ACTIVE: {
          const isDoughProActiveResult = parseInt(value, 10) === 1;
          if (isDoughProActive === isDoughProActiveResult) {
            break;
          }
          setIsDoughProActive(isDoughProActiveResult);
          break;
        }
        case siteSetting.SHIPPING_ACTIVE: {
          const isShippingActiveResult = parseInt(value, 10) === 1;

          if (isShippingActive === isShippingActiveResult) {
            break;
          }
          setIsShippingActive(isShippingActiveResult);
          break;
        }
        case siteSetting.FEEDBACK_FORMS_ENABLED: {
          const feedbackFormsEnabled = parseInt(value, 10) === 1;
          setIsFeedbackFormsEnabled(feedbackFormsEnabled);
          break;
        }
        case siteSetting.SHOW_CALORIES: {
          const isCaloriesActiveResult = parseInt(value, 10) === 1;
          if (isCaloriesActive === isCaloriesActiveResult) {
            break;
          }
          setIsCaloriesActive(isCaloriesActiveResult);
          break;
        }
        case siteSetting.COUNTRY_SELECTION_ENABLED: {
          const countrySelectActiveResult = parseInt(value, 10) === 1;
          if (isCountrySelectActive === countrySelectActiveResult) {
            break;
          }
          setIsCountrySelectActive(countrySelectActiveResult);
          break;
        }
        case siteSetting.DEFAULT_HERO_BANNER: {
          const defaultHeroBanner = JSON.parse(value);
          setDefaultHeroBanner(defaultHeroBanner);
          break;
        }
        case siteSetting.CAROUSEL_SLIDE_SPEED: {
          const carouselSpeed = parseInt(value, 10);
          setCarouselSpeed(carouselSpeed);
          break;
        }
        case siteSetting.INTRO_HERO_BANNER: {
          const introHeroBanner = JSON.parse(value);
          setIntroHeroBanner(introHeroBanner);
          break;
        }
        case siteSetting.IS_CONTENT_CARD_FULL_WIDTH: {
          setIscontentCardFullWidth(value === "1");
          break;
        }
        case siteSetting.TIKTOK_LINK: {
          setTiktokLink(value);
          break;
        }
        case siteSetting.INSTAGRAM_LINK: {
          setInstagramLink(value);
          break;
        }
        case siteSetting.FACEBOOK_LINK: {
          setFacebookLink(value);
          break;
        }
        case siteSetting.ENABLE_DELIEVRY_PICKUP_SWITCH: {
          setDeliveryPickupWidgetEnabled(value === "1");
          break;
        }
        case siteSetting.IS_FOOTER_MENU_NEWSROOM_ENABLED:
        case siteSetting.IS_FOOTER_MENU_FAQ_ENABLED:
        case siteSetting.IS_FOOTER_MENU_PRIVACY_POLICY_ENABLED:
        case siteSetting.IS_FOOTER_MENU_TERMS_ENABLED:
        case siteSetting.IS_FOOTER_MENU_EVENT_TERMS_ENABLED:
        case siteSetting.IS_FOOTER_MENU_ACCESSIBILITY_ENABLED:
        case siteSetting.IS_FOOTER_MENU_CONTACT_ENABLED:
        case siteSetting.IS_FOOTER_MENU_ABOUT_US_ENABLED:
        case siteSetting.IS_FOOTER_MENU_CAREERS_ENABLED:
        case siteSetting.IS_FOOTER_MENU_CORPORATE_SALES_ENABLED:
        case siteSetting.IS_FOOTER_MENU_DONATIONS_ENABLED:
        case siteSetting.IS_FOOTER_MENU_ALLERGEN_ENABLED:
        case siteSetting.IS_FOOTER_MENU_PROMOTIONS_TERMS_AND_CONDITIONS_ENABLED:
        case siteSetting.IS_FOOTER_MENU_MERCH_ENABLED: {
          footerMenuItemsSettings[name] = Number(value) === 1;
          break;
        }
        case siteSetting.FOOTER_MENU_NEWSROOM_LINK:
        case siteSetting.FOOTER_MENU_FAQ_LINK:
        case siteSetting.FOOTER_MENU_PRIVACY_POLICY_LINK:
        case siteSetting.FOOTER_MENU_TERMS_LINK:
        case siteSetting.FOOTER_MENU_EVENT_TERMS_LINK:
        case siteSetting.FOOTER_MENU_ACCESSIBILITY_LINK:
        case siteSetting.FOOTER_MENU_CONTACT_LINK:
        case siteSetting.FOOTER_MENU_ABOUT_US_LINK:
        case siteSetting.FOOTER_MENU_CAREERS_LINK:
        case siteSetting.FOOTER_MENU_CORPORATE_SALES_LINK:
        case siteSetting.FOOTER_MENU_DONATIONS_LINK:
        case siteSetting.FOOTER_MENU_ALLERGEN_LINK:
        case siteSetting.FOOTER_MENU_PROMOTIONS_TERMS_AND_CONDITIONS_LINK:
        case siteSetting.FOOTER_MENU_MERCH_LINK: {
          if ((value || "").trim().indexOf("http") === -1) {
            footerMenuItemsLinks[name] = value;
          } else {
            footerMenuItemsLinks[name] = value;
          }
          break;
        }
        case siteSetting.TIPS_TYPE: {
          tipsSettings[siteSetting.TIPS_TYPE] = value;
          break;
        }
        case siteSetting.TIPS_VALUES: {
          tipsSettings[siteSetting.TIPS_VALUES] = JSON.parse(value);
          break;
        }
        case siteSetting.DISABLE_GIFTCARDS: {
          setIsGiftcardDisabled(value);
          break;
        }
        case siteSetting.ORDER_TOTALS_TITLES: {
          setOrderTotalsTitles(value);
          break;
        }
        case siteSetting.SHOW_TAXES_AFTER_TOTAL: {
          setShowTaxesAfterTotal(Number(value) === 1);
          break;
        }
        case siteSetting.MAP_DEFAULT_COORDINATES: {
          const defaultMapCoordinates = JSON.parse(value);
          setDefaultMapCoordinates(defaultMapCoordinates);
          break;
        }
        case siteSetting.USE_FULLY_QUALIFIED_ADDRESS_FOR_DELIVERY: {
          const useFullyQualifiedAddressForDelivery = Number(value) === 1;
          setUseFullyQualifiedAddressForDelivery(
            useFullyQualifiedAddressForDelivery
          );
          break;
        }
        case siteSetting.IS_CONTACT_US_FEEDBACK_ENABLE:
        case siteSetting.IS_CONTACT_US_GENERAL_ENABLE:
        case siteSetting.IS_CONTACT_US_EVENTS_ENABLE:
        case siteSetting.IS_CONTACT_US_REAL_ESTATE_ENABLE:
        case siteSetting.IS_CONTACT_US_VENDOR_ENABLE:
        case siteSetting.IS_CONTACT_US_PRESS_ENABLE:
        case siteSetting.IS_CONTACT_US_MERCH_ENABLE:
        case siteSetting.IS_CONTACT_US_DONATION_ENABLE:
        case siteSetting.CONTACT_US_FEEDBACK_EMAILS:
        case siteSetting.CONTACT_US_GENERAL_EMAILS:
        case siteSetting.CONTACT_US_EVENTS_EMAILS:
        case siteSetting.CONTACT_US_REAL_ESTATE_EMAILS:
        case siteSetting.CONTACT_US_VENDOR_EMAILS:
        case siteSetting.CONTACT_US_PRESS_EMAILS: {
          if ((value || "").trim().indexOf("@") === -1) {
            contactUsSetting[name] = value;
          } else {
            contactUsSetting[name] = value;
          }
          break;
        }
        case siteSetting.IS_THEME_SWITCH_ENABLED: {
          const themeActive = parseInt(value, 10);
          themeSettings[siteSetting.IS_THEME_SWITCH_ENABLED] =
            themeActive === 1;
          setThemeSettings(themeSettings);
          break;
        }
        case siteSetting.PASSWORDLESS_EMAIL_LOGIN_ENABLED: {
          passwordlessEmailLoginEnabledValue = !!+value;
          break;
        }
        case siteSetting.OTP_AUTHENTICATION_ENABLED: {
          try {
            const otpAuthJson = JSON.parse(value);
            otpAuthenticationEnabledWebsite = parseInt(otpAuthJson[elementConstant.consumerPlatform], 10) === 1;
          } catch (e) {
            otpAuthenticationEnabledWebsite = false;
          }
          break;
        }
        case siteSetting.ACTIVE_LOYALTY: {
          setActiveLoyaltySetting(value);
          break;
        }
        case siteSetting.REFERRAL_ENABLED: {
          const referralEnabled = parseInt(value, 10) === 1;
          setReferralEnabledSetting(referralEnabled);
          break;
        }
        case siteSetting.USE_RECAPTCHA: {
          const useRecaptchaJson = JSON.parse(value);
          const useRecaptcha =
            parseInt(useRecaptchaJson[elementConstant.consumerPlatform], 10) ??
            0;
          setUseRecaptcha(useRecaptcha);
          break;
        }
        case siteSetting.SHOW_EVERGREEN_OOS_PRODUCTS: {
          setIsShowOosProducts(parseInt(value, 10) === 1);
          break;
        }
        case siteSetting.PLATFORM_WALLET_LOYALTY_CARD_FEATURE: {
          setPlatformWalletLoyaltyCardFeature(parseInt(value, 10) === 1);
          break;
        }
        case siteSetting.DATA_COLLECTION_DELAY_MILLISECONDS: {
          setDataCollectionDelay(parseInt(value, 10));
          break;
        }
        case siteSetting.MOCK_BRAZE_CONTENT_CARDS: {
          setMockBrazeContentCards(value);
          break;
        }
        case siteSetting.ASSETS.ASSETS_LINK: {
          setBrazeContentCardLink(value);
          break;
        }
        case siteSetting.ASSETS.ASSETS_LINK_REPLACE_WITH: {
          setBrazeContentCardLinkReplaceWith(value);
          break;
        }
        case siteSetting.EVENT.EVENT_TILL: {
          setEventEndDate(value);
          break;
        }
        case siteSetting.EVENT.EVENT_APPLICATION_LOGO_WEBSITE: {
          setEventApplicationLogoWebsite(value);
          break;
        }
        case siteSetting.EVENT.EVENT_APPLICATION_LOGO_MOBILE: {
          setEventApplicationLogoMobile(value);
          break;
        }
        default: {
          break;
        }
      }
    });
    
    // Set passwordless email login based on both conditions:
    // 1. passwordless_email_login_enabled = true
    // 2. otp_authentication_enabled.website = true
    setPasswordlessEmailLoginEnable(
      passwordlessEmailLoginEnabledValue && otpAuthenticationEnabledWebsite
    );
    setOtpAuthenticationEnabledWebsite(otpAuthenticationEnabledWebsite);

    setFooterMenuItemsSettings(footerMenuItemsSettings);
    setFooterMenuItemsLinksSettings(footerMenuItemsLinks);
    setTipsSettings(tipsSettings);
    setContactUsSettings(contactUsSetting);
    setThemeSettings(themeSettings);
    return specificSettings;
  };

  getSiteSettings = () => {
    const { errorMessage } = this.props;
    return new Promise((resolve, reject) => {
      if (!errorMessage) {
        siteSettingRepo
          .getSiteSettings(
            [
              siteSetting.COOKIE_MAGIC_ACTIVE,
              siteSetting.SHIPPING_ACTIVE,
              siteSetting.SHOW_CALORIES,
              siteSetting.COUNTRY_SELECTION_ENABLED,
              siteSetting.BRAZE_APP_ID_WEB,
              siteSetting.BRAZE_VERBOSE_LOGGING,
              siteSetting.CONTENT_CARD_REFRESH_DELAY,
              siteSetting.DEFAULT_HERO_BANNER,
              siteSetting.CAROUSEL_SLIDE_SPEED,
              siteSetting.INTRO_HERO_BANNER,
              siteSetting.IS_CONTENT_CARD_FULL_WIDTH,
              siteSetting.IS_FOOTER_MENU_NEWSROOM_ENABLED,
              siteSetting.IS_FOOTER_MENU_FAQ_ENABLED,
              siteSetting.IS_FOOTER_MENU_PRIVACY_POLICY_ENABLED,
              siteSetting.IS_FOOTER_MENU_TERMS_ENABLED,
              siteSetting.IS_FOOTER_MENU_EVENT_TERMS_ENABLED,
              siteSetting.IS_FOOTER_MENU_ACCESSIBILITY_ENABLED,
              siteSetting.IS_FOOTER_MENU_CONTACT_ENABLED,
              siteSetting.IS_FOOTER_MENU_ABOUT_US_ENABLED,
              siteSetting.IS_FOOTER_MENU_CAREERS_ENABLED,
              siteSetting.IS_FOOTER_MENU_CORPORATE_SALES_ENABLED,
              siteSetting.IS_FOOTER_MENU_DONATIONS_ENABLED,
              siteSetting.IS_FOOTER_MENU_MERCH_ENABLED,
              siteSetting.IS_FOOTER_MENU_PROMOTIONS_TERMS_AND_CONDITIONS_ENABLED,
              siteSetting.IS_FOOTER_MENU_ALLERGEN_ENABLED,
              siteSetting.FOOTER_MENU_NEWSROOM_LINK,
              siteSetting.FOOTER_MENU_FAQ_LINK,
              siteSetting.FOOTER_MENU_PRIVACY_POLICY_LINK,
              siteSetting.FOOTER_MENU_TERMS_LINK,
              siteSetting.FOOTER_MENU_EVENT_TERMS_LINK,
              siteSetting.FOOTER_MENU_ACCESSIBILITY_LINK,
              siteSetting.FOOTER_MENU_CONTACT_LINK,
              siteSetting.FOOTER_MENU_ABOUT_US_LINK,
              siteSetting.FOOTER_MENU_CAREERS_LINK,
              siteSetting.FOOTER_MENU_CORPORATE_SALES_LINK,
              siteSetting.FOOTER_MENU_DONATIONS_LINK,
              siteSetting.FOOTER_MENU_MERCH_LINK,
              siteSetting.FOOTER_MENU_PROMOTIONS_TERMS_AND_CONDITIONS_LINK,
              siteSetting.FOOTER_MENU_ALLERGEN_LINK,
              siteSetting.TIKTOK_LINK,
              siteSetting.INSTAGRAM_LINK,
              siteSetting.FACEBOOK_LINK,
              siteSetting.TIPS_TYPE,
              siteSetting.TIPS_VALUES,
              siteSetting.DISABLE_GIFTCARDS,
              siteSetting.DATADOG_RUM_ENABLED,
              siteSetting.ORDER_TOTALS_TITLES,
              siteSetting.SHOW_TAXES_AFTER_TOTAL,
              siteSetting.MAP_DEFAULT_COORDINATES,
              siteSetting.DISABLE_SAVE_CARD,
              siteSetting.IS_CONTACT_US_FEEDBACK_ENABLE,
              siteSetting.IS_CONTACT_US_GENERAL_ENABLE,
              siteSetting.IS_CONTACT_US_EVENTS_ENABLE,
              siteSetting.IS_CONTACT_US_REAL_ESTATE_ENABLE,
              siteSetting.IS_CONTACT_US_VENDOR_ENABLE,
              siteSetting.IS_CONTACT_US_PRESS_ENABLE,
              siteSetting.IS_CONTACT_US_MERCH_ENABLE,
              siteSetting.IS_CONTACT_US_DONATION_ENABLE,
              siteSetting.CONTACT_US_FEEDBACK_EMAILS,
              siteSetting.CONTACT_US_GENERAL_EMAILS,
              siteSetting.CONTACT_US_EVENTS_EMAILS,
              siteSetting.CONTACT_US_REAL_ESTATE_EMAILS,
              siteSetting.CONTACT_US_VENDOR_EMAILS,
              siteSetting.CONTACT_US_PRESS_EMAILS,
              siteSetting.USE_FULLY_QUALIFIED_ADDRESS_FOR_DELIVERY,
              siteSetting.IS_THEME_SWITCH_ENABLED,
              siteSetting.PASSWORDLESS_EMAIL_LOGIN_ENABLED,
              siteSetting.OTP_AUTHENTICATION_ENABLED,
              siteSetting.ACTIVE_LOYALTY,
              siteSetting.REFERRAL_ENABLED,
              siteSetting.USE_RECAPTCHA,
              siteSetting.SHOW_EVERGREEN_OOS_PRODUCTS,
              siteSetting.FEEDBACK_FORMS_ENABLED,
              siteSetting.PLATFORM_WALLET_LOYALTY_CARD_FEATURE,
              siteSetting.DATA_COLLECTION_DELAY_MILLISECONDS,
              siteSetting.ENABLE_GUEST_USERS_LAST_ORDER_ADDRESS,
              siteSetting.ENABLE_DELIEVRY_PICKUP_SWITCH,
              siteSetting.ASSETS.ASSETS_LINK,
              siteSetting.ASSETS.ASSETS_LINK_REPLACE_WITH,
              siteSetting.EVENT.EVENT_TILL,
              siteSetting.EVENT.EVENT_APPLICATION_LOGO_WEBSITE,
              siteSetting.EVENT.EVENT_APPLICATION_LOGO_MOBILE,
              siteSetting.MOCK_BRAZE_CONTENT_CARDS
            ],
            true
          )
          .then(response => {
            if (!response || !response.data || !response.data.siteSettings) {
              reject(response);
              return;
            }
            resolve(response);
          })
          .catch(reject);
      } else {
        reject();
      }
    });
  };

  transformLocation = currentLocation => {
    const { isCountrySelectActive, selectedCountry, history } = this.props;
    // Adding country url to prefix
    // If we have selected country and have no path_url in current path so add it

    if (
      isCountrySelectActive &&
      selectedCountry.path_url &&
      !isHasCountryPathInLocation(
        currentLocation.pathname,
        selectedCountry.path_url
      )
    ) {
      const tmp = removeCountryPathFromLocation(currentLocation.pathname);
      const newLocation = addCountryPathToLocation(
        tmp,
        selectedCountry.path_url,
        isCountrySelectActive
      );
      if (
        window.location.pathname !== newLocation ||
        window.location.search !== currentLocation.search
      ) {
        history.replace({
          pathname: newLocation,
          search: currentLocation.search,
          state: currentLocation.state
        });
        return null;
      }
    }
    const path = currentLocation;
    // Removing path url from pathname for backward compatibility. To not add selected country path url to all links of system
    if (
      isCountrySelectActive &&
      selectedCountry.path_url &&
      isHasCountryPathInLocation(
        currentLocation.pathname,
        selectedCountry.path_url
      )
    ) {
      path.pathname = getLocationWithoutCountryPath(
        currentLocation.pathname,
        selectedCountry.path_url
      );
    }

    return path;
  };

  handleCheckout = async e => {
    const {
      userCart,
      history,
      userCartId,
      userOrderMethod,
      orderMinAmount,
      currency,
      setOrderMinAmount,
      order,
    } = this.props;
    e.preventDefault();
    let minAmount = orderMinAmount;
    let isMinAmount = false;
    const cartIconLink = endpoints.checkoutOrderPage.replace(":id", userCartId);
    let orderObj = order;
    if (userCart.length > 0 && userOrderMethod === orderMethods.delivery) {
      if (!minAmount) {
        const orderResp = await orderRepo.getOrder(userCartId);
        setOrderMinAmount(orderResp?.data?.order?.shippingMethodMinAmount);
        minAmount = orderResp?.data?.order?.shippingMethodMinAmount;
        orderObj = orderResp?.data?.order;
      }

      const totalPrice = getCartSubtotal(userCart);
      const loyaltyDiscountAmount = getLoyaltyDiscountAmount(orderObj);
      if ((totalPrice - loyaltyDiscountAmount) < minAmount) {
        orderRepo.orderEvent(OrderEvent.CHECKOUT_ATTEMPTED, userCartId, {
          cartSubtotal: totalPrice,
          productIds: getCartProductIds(userCart)
        });
        checkoutOrderMinAmount(minAmount, currency.symbol);
        isMinAmount = true;
      }
    }
    if (!isMinAmount) {
      history.push(routeCountryPath(cartIconLink));
    }
  };

  render = () => {
    const { isLoading } = this.state;
    const {
      modalObject,
      errorMessage,
      location,
      topHeaderOffsetDivHeight,
      userCart,
      currency,
      showMobileMenu
    } = this.props;

    const currentLocation = location;
    // Single source of truth for "how much sticky chrome sits above page content"
    // (currently just the ribbon). Exposed to descendants via the
    // --content-top-offset CSS custom property so any page/route can position
    // its own sticky/fixed elements (fullscreen carousel, sticky filters, etc.)
    // without re-reading ribbon state.
    const ribbonVisible =
      topHeaderOffsetDivHeight > elementConstant.topHeaderOffsetDivHeightDefault;
    let ribbonHeight = 0;
    if (ribbonVisible) {
      ribbonHeight = isBrandRefreshEnabled() ? 36 : 40;
    }

    if (isLoading === false) {
      const newLocation = this.transformLocation(currentLocation);
      if (newLocation === null) {
        return null;
      }
      const { pathname } = newLocation;
      const isCheckoutPage = pathname.match(/checkout\/review-order/g);
      const isProductPage = pathname.match(/products\//g);
      const isMenuPage = pathname.includes("/menu");
      const isValentinesDayReservationsPage = pathname.includes(
        "/valentines-reservations"
      );

      const showDeliveryPickupAddressBar = !isValentinesDayReservationsPage;
      const { useFullscreenCarousel } = this.props;
      // Full-screen homepage intentionally omits the footer; other pages must keep it.
      const isHomepage =
        pathname === endpoints.homePage || /^\/[a-z]{2}\/?$/.test(pathname);
      const hideFooterOnFullscreenHomepage =
        useFullscreenCarousel && isHomepage;

      if (showMobileMenu && !useFullscreenCarousel) return <MobileMenu location={pathname} />;

      // Note: Page title and description are now handled in componentDidMount and componentDidUpdate
      // to avoid race conditions and redundant calls during render

      return (
        <>
          <div
            className={styles.pageContainerContent}
            style={{ "--content-top-offset": `${ribbonHeight}px` }}
          >
            {modalObject ? <Modal {...modalObject} /> : null}
            {" "}
            {/* eslint-disable-line */}
            {/* GLOBAL BACKGROUND RENDERING */}
            {/* {renderBackground(pathname)} */}
            {/* GLOBAL HEADER RENDERING */}
            {renderGlobalHeader(
              pathname,
              topHeaderOffsetDivHeight,
              errorMessage,
              showDeliveryPickupAddressBar
            )}
            {/* MAIN ROUTES */}
            <div className={`w-full flex flex-col gap-9 `}>
              {errorMessage ? (
                <Error errorType="400" />
              ) : (
                <Switch location={currentLocation}>
                  {/* User Routes */}
                  <Route path="/user" component={UserRoutes} />
                  {/* Product Routes */}
                  <Route path="/products" component={ProductRoutes} />
                  {/* Checkout Routes */}
                  <Route path="/checkout" component={CheckoutRoutes} />
                  {/* FALLBACK 404 PATH */}
                  <Route path="/404" component={NoMatch} />
                  {/* Index Routes */}
                  <Route path="/" component={IndexRoutes} />
                  {/* CATCH ALL - REDIRECT TO 404 */}
                  <Redirect to="404" />
                </Switch>
              )}

              {userCart.length > 0 && !isCheckoutPage && !isProductPage ? (
                <div
                  className={styles.floatButtonContainer}
                  data-region={getStickyCtaRegionProps()}
                  data-menu={getCheckoutButtonMenuProps(isMenuPage)}
                >
                  {useFullscreenCarousel ? (
                    <FullScreenCheckoutButton
                      label="Checkout"
                      currency={currency}
                      onClick={this.handleCheckout}
                      isMenuPage={isMenuPage}
                    />
                  ) : (
                    <CheckoutButton
                      label="Checkout"
                      currency={currency}
                      onClick={this.handleCheckout}
                      isCheckout
                      isMenuPage={isMenuPage}
                    />
                  )}
                </div>
              ) : null}
            </div>
            {!hideFooterOnFullscreenHomepage && renderGlobalFooter(pathname)}
            <PostOrderExperienceModal />
            <BigOrderWarningModal />
          </div>
        </>
      );
    }
    return (
      <div>
        <div className={styles.loaderBlock}>
          <Loader />
        </div>
      </div>
    );
  };
}

PageContainer.propTypes = {
  showMobileMenu: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  modalObject: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string
  }),
  isCountrySelectActive: PropTypes.bool,
  selectedCountry: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    path_url: PropTypes.string,
    api_url: PropTypes.string,
    short_name: PropTypes.string,
    url: PropTypes.string,
    zone_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currency: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
      symbol: PropTypes.string
    })
  }),
  setSelectedCountry: PropTypes.func.isRequired,
  setUserZoneId: PropTypes.func.isRequired,
  setAllCountries: PropTypes.func.isRequired,
  setIsCountrySelectActive: PropTypes.func.isRequired,
  setIsDoughProActive: PropTypes.func.isRequired,
  setIsFeedbackFormsEnabled: PropTypes.func.isRequired,
  setIsCaloriesActive: PropTypes.func.isRequired,
  setIsShippingActive: PropTypes.func.isRequired,
  resetUserData: PropTypes.func.isRequired,
  resetCustomCakeTopperData: PropTypes.func.isRequired,
  resetCurrencyData: PropTypes.func.isRequired,
  isDoughProActive: PropTypes.bool,
  isShippingActive: PropTypes.bool,
  isCaloriesActive: PropTypes.bool,
  history: PropTypes.shape({
    replace: PropTypes.func,
    push: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  }).isRequired,
  topHeaderOffsetDivHeight: PropTypes.number.isRequired,
  introBannerVisibilityUpdated: PropTypes.func.isRequired,
  shouldDisplayIntroBanner: PropTypes.bool,
  setDefaultHeroBanner: PropTypes.func.isRequired,
  setCarouselSpeed: PropTypes.func.isRequired,
  setIscontentCardFullWidth: PropTypes.func.isRequired,
  setIntroHeroBanner: PropTypes.func.isRequired,
  setContentCardRefreshDelay: PropTypes.func.isRequired,
  setFooterMenuItemsSettings: PropTypes.func.isRequired,
  setFooterMenuItemsLinksSettings: PropTypes.func.isRequired,
  setTiktokLink: PropTypes.func.isRequired,
  setInstagramLink: PropTypes.func.isRequired,
  setFacebookLink: PropTypes.func.isRequired,
  setTipsSettings: PropTypes.func.isRequired,
  setIsGiftcardDisabled: PropTypes.func.isRequired,
  setOrderTotalsTitles: PropTypes.func.isRequired,
  setShowTaxesAfterTotal: PropTypes.func.isRequired,
  setDefaultMapCoordinates: PropTypes.func.isRequired,
  currency: PropTypes.objectOf(PropTypes.string),
  userCartId: PropTypes.string,
  userCart: PropTypes.arrayOf(PropTypes.shape()),
  setContactUsSettings: PropTypes.func.isRequired,
  userOrderMethod: PropTypes.string,
  setOrderMinAmount: PropTypes.func.isRequired,
  orderMinAmount: PropTypes.number,
  setUseFullyQualifiedAddressForDelivery: PropTypes.func.isRequired,
  setThemeSettings: PropTypes.func.isRequired,
  setPasswordlessEmailLoginEnable: PropTypes.func.isRequired,
  setOtpAuthenticationEnabledWebsite: PropTypes.func.isRequired,
  setActiveLoyaltySetting: PropTypes.func.isRequired,
  setReferralEnabledSetting: PropTypes.func.isRequired,
  setUseRecaptcha: PropTypes.func.isRequired,
  setIsShowOosProducts: PropTypes.func.isRequired,
  setPlatformWalletLoyaltyCardFeature: PropTypes.func.isRequired,
  dataCollectionDelay: PropTypes.number,
  setDataCollectionDelay: PropTypes.func.isRequired,
  setMockBrazeContentCards: PropTypes.func.isRequired,
  setEnableDefaultAddressForGuestUsers: PropTypes.func.isRequired,
  setDeliveryPickupWidgetEnabled: PropTypes.func.isRequired,
  setBrazeContentCardLink: PropTypes.func.isRequired,
  setBrazeContentCardLinkReplaceWith: PropTypes.func.isRequired,
  setEventEndDate: PropTypes.func.isRequired,
  setEventApplicationLogoWebsite: PropTypes.func.isRequired,
  setEventApplicationLogoMobile: PropTypes.func.isRequired,
  useFullscreenCarousel: PropTypes.bool,
  isNewNavVariant: PropTypes.bool,
  order: PropTypes.shape(),
};

PageContainer.defaultProps = {
  modalObject: null,
  errorMessage: "",
  isCountrySelectActive: false,
  selectedCountry: defaultCountry,
  isDoughProActive: false,
  isShippingActive: false,
  isCaloriesActive: false,
  shouldDisplayIntroBanner: true,
  currency: defaultCurrency,
  userCartId: null,
  userCart: [],
  userOrderMethod: "",
  orderMinAmount: null,
  dataCollectionDelay: 0,
  useFullscreenCarousel: isBrandRefreshEnabled(),
  isNewNavVariant: false,
  order: null,
};

export const mapStateToProps = state => {
  const {
    modalObject,
    topHeaderOffsetDivHeight,
    orderMinAmount,
    showMobileMenu
  } = state.elements;
  const { isDoughProActive } = state.doughPro;
  const { isShippingActive } = state.shipping;
  const { isCaloriesActive } = state.product;
  const {
    selectedCountry,
    allCountries,
    isCountrySelectActive
  } = state.country;

  const { shouldDisplayIntroBanner } = state.braze;
  const { passwordlessEmailLoginEnabled } = state.footerSettings;
  const { siteSettings } = state;
  const { order } = state;
  return {
    modalObject,
    selectedCountry,
    allCountries,
    isCountrySelectActive,
    isDoughProActive,
    isShippingActive,
    isCaloriesActive,
    topHeaderOffsetDivHeight,
    shouldDisplayIntroBanner,
    userCart: state.user.userCart,
    userCartId: state.user.userCartId,
    userOrderMethod: state.user.userOrderMethod,
    orderMinAmount,
    passwordlessEmailLoginEnabled,
    dataCollectionDelay: siteSettings?.dataCollectionDelay,
    showMobileMenu,
    order,
  };
};

export const mapDispatchToProps = dispatch => {
  const setAllCountries = value =>
    dispatch(countryActions.setAllCountries(value));
  const setSelectedCountry = value =>
    dispatch(countryActions.setSelectedCountry(value));
  const setIsDoughProActive = value =>
    dispatch(doughProActions.setIsDoughProActive(value));
  const setIsShippingActive = value =>
    dispatch(shippingActions.setIsShippingActive(value));
  const setIsCaloriesActive = value =>
    dispatch(productActions.setIsCaloriesActive(value));
  const setIsShowOosProducts = value =>
    dispatch(productActions.setIsShowOosProducts(value));
  const setPlatformWalletLoyaltyCardFeature = value =>
    dispatch(loyaltyActions.setPlatformWalletLoyaltyCardFeature(value));
  const setIsCountrySelectActive = value =>
    dispatch(countryActions.setIsCountrySelectActive(value));

  const introBannerVisibilityUpdated = value =>
    dispatch(brazeActions.introBannerVisibilityUpdated(value));

  const setDefaultHeroBanner = value =>
    dispatch(brazeActions.setDefaultHeroBanner(value));

  const setCarouselSpeed = value =>
    dispatch(elementsActions.setCarouselSpeed(value));

  const setIscontentCardFullWidth = value =>
    dispatch(elementsActions.setIscontentCardFullWidth(value));

  const setIntroHeroBanner = value =>
    dispatch(brazeActions.setIntroHeroBanner(value));

  const setContentCardRefreshDelay = value =>
    dispatch(brazeActions.setContentCardRefreshDelay(value));

  const setBrazeContentCardLink = value =>
    dispatch(brazeActions.setBrazeContentCardLink(value));

  const setBrazeContentCardLinkReplaceWith = value =>
    dispatch(brazeActions.setBrazeContentCardLinkReplaceWith(value));

  const setTiktokLink = value =>
    dispatch(footerSettingsActions.setTiktokLink(value));

  const setInstagramLink = value =>
    dispatch(footerSettingsActions.setInstagramLink(value));

  const setFacebookLink = value =>
    dispatch(footerSettingsActions.setFacebookLink(value));

  const setFooterMenuItemsSettings = value =>
    dispatch(footerSettingsActions.setFooterMenuItemsSettings(value));
  const setFooterMenuItemsLinksSettings = value =>
    dispatch(footerSettingsActions.setFooterMenuItemsLinksSettings(value));
  const setTipsSettings = value => dispatch(tipsActions.setTipsSettings(value));

  const setIsGiftcardDisabled = value =>
    dispatch(giftCardActions.setIsGiftcardDisabled(value));

  const setOrderTotalsTitles = value =>
    dispatch(orderTotalsTitles.setOrderTotalsTitles(value));

  const setShowTaxesAfterTotal = value =>
    dispatch(orderTotalsTitles.setShowTaxesAfterTotal(value));

  const setDefaultMapCoordinates = value =>
    dispatch(elementsActions.setDefaultMapCoordinates(value));
  const setContactUsSettings = value =>
    dispatch(contactUsSettingActions.setContactUsSettings(value));

  const setUserZoneId = value => dispatch(userActions.setUserZoneId(value));

  const resetUserData = () => dispatch(userActions.resetUserData());
  const resetCustomCakeTopperData = () =>
    dispatch(customCakeTopperActions.resetCustomCakeTopperData());
  const resetCurrencyData = () => dispatch(currencyActions.resetCurrencyData());

  const setOrderMinAmount = value =>
    dispatch(elementsActions.setOrderMinAmount(value));

  const setUseFullyQualifiedAddressForDelivery = value =>
    dispatch(addressActions.setUseFullyQualifiedAddressForDelivery(value));

  const setThemeSettings = value =>
    dispatch(themeActions.setThemeSettings(value));

  const setPasswordlessEmailLoginEnable = value =>
    dispatch(footerSettingsActions.setPasswordlessEmailLoginEnable(value));
  const setOtpAuthenticationEnabledWebsite = value =>
    dispatch(footerSettingsActions.setOtpAuthenticationEnabledWebsite(value));
  const setActiveLoyaltySetting = value =>
    dispatch(loyaltyActions.setActiveLoyaltySetting(value));
  const setReferralEnabledSetting = value =>
    dispatch(loyaltyActions.setReferralEnabledSetting(value));
  const setUseRecaptcha = value =>
    dispatch(elementsActions.setUseRecaptcha(value));
  const setIsFeedbackFormsEnabled = value =>
    dispatch(siteSettingsActions.setIsFeedbackFormsEnabled(value));
  const setDataCollectionDelay = value =>
    dispatch(siteSettingsActions.setDataCollectionDelay(value));
  const setMockBrazeContentCards = value =>
    dispatch(siteSettingsActions.setMockBrazeContentCards(value));
  const setEnableDefaultAddressForGuestUsers = value =>
    dispatch(addressActions.setEnableDefaultAddressForGuestUsers(value));

  const setDeliveryPickupWidgetEnabled = value =>
    dispatch(elementsActions.setDeliveryPickupWidgetEnabled(value));

  const setEventEndDate = value =>
    dispatch(eventActions.setEventEndDate(value));
  const setEventApplicationLogoWebsite = value =>
    dispatch(eventActions.setEventApplicationLogoWebsite(value));
  const setEventApplicationLogoMobile = value =>
    dispatch(eventActions.setEventApplicationLogoMobile(value));

  return {
    setAllCountries,
    setSelectedCountry,
    setIsCountrySelectActive,
    setIsDoughProActive,
    setIsShippingActive,
    setIsCaloriesActive,
    introBannerVisibilityUpdated,
    setDefaultHeroBanner,
    setCarouselSpeed,
    setIscontentCardFullWidth,
    setIntroHeroBanner,
    setContentCardRefreshDelay,
    setTiktokLink,
    setInstagramLink,
    setFacebookLink,
    setFooterMenuItemsSettings,
    setFooterMenuItemsLinksSettings,
    setTipsSettings,
    setIsGiftcardDisabled,
    setOrderTotalsTitles,
    setShowTaxesAfterTotal,
    setDefaultMapCoordinates,
    setUserZoneId,
    resetUserData,
    resetCustomCakeTopperData,
    resetCurrencyData,
    setContactUsSettings,
    setOrderMinAmount,
    setUseFullyQualifiedAddressForDelivery,
    setThemeSettings,
    setPasswordlessEmailLoginEnable,
    setOtpAuthenticationEnabledWebsite,
    setActiveLoyaltySetting,
    setReferralEnabledSetting,
    setUseRecaptcha,
    setIsShowOosProducts,
    setIsFeedbackFormsEnabled,
    setPlatformWalletLoyaltyCardFeature,
    setDataCollectionDelay,
    setMockBrazeContentCards,
    setEnableDefaultAddressForGuestUsers,
    setDeliveryPickupWidgetEnabled,
    setBrazeContentCardLink,
    setBrazeContentCardLinkReplaceWith,
    setEventEndDate,
    setEventApplicationLogoWebsite,
    setEventApplicationLogoMobile
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PageContainer)
);
